import React, {useEffect, useState} from 'react';
import {InfoDialog} from '../components/InfoDialog';
import {useEstadisticasCRM} from '../hooks/useEstadisticasCRM';
import {ClientesSinContacto} from '../../bussines/entities/EstadisticasCRM.entity';

const columns = [
   {
      name: 'codCliente',
      label: 'DNI/RUC',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'clienteDenominacion',
      label: 'Cliente',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'producto',
      label: 'Producto',
      options: {
         filter: true,
         display: 'true'
      }
   },
   {
      name: 'fecha',
      label: 'Fecha de Contacto',
      options: {
         filter: true,
         display: 'true'
      }
   }
];

export const CardClientesSinContacto: React.FC<{fecha: Date}> = ({fecha}) => {
   const [clientesSinContacto, setClientesSinContacto] = useState<ClientesSinContacto[]>([]);
   const {getClientesSinContacto} = useEstadisticasCRM();
   const fetchClientesSinContacto = async () => {
      const result = await getClientesSinContacto({fecha: fecha});
      if (result) {
         setClientesSinContacto(result);
      }
   };

   useEffect(() => {
      fetchClientesSinContacto();
   }, []);
   return (
      <InfoDialog
         descripcion="Clientes sin Contacto en más de 30 dias"
         isCriticalValue
         list={clientesSinContacto}
         columns={columns}
      />
   );
};
